export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
    width: 1280,
    height: 720,
    frameRate: 24,
};
export const BLUR_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
    width: 700,
    height: 500,
    frameRate: 24,
};
// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = 'TwilioVideoApp-selectedAudioInput';
export const SELECTED_AUDIO_OUTPUT_KEY = 'TwilioVideoApp-selectedAudioOutput';
export const SELECTED_VIDEO_INPUT_KEY = 'TwilioVideoApp-selectedVideoInput';

// This is used to store the current background settings in localStorage
export const SELECTED_BACKGROUND_SETTINGS_KEY = 'TwilioVideoApp-selectedBackgroundSettings';
export const INPUT_TEST_DURATION = 20000;

export const RECORD_DURATION = 5000;

export const AUDIO_LEVEL_THRESHOLD = 200;

export const AUDIO_LEVEL_STANDARD_DEVIATION_THRESHOLD = AUDIO_LEVEL_THRESHOLD * 0.05; // 5% threshold
export const BRAND_TITLE = 'Medihub360';
export const EMPLOYER_RELATIONSHIP_CODE = 10004;
export const SELF_RELATIONSHIP_CODE = 10010;
